"use client";

import React from "react";
import {useTranslation} from "react-i18next";
import Input from "@/components/library/Input";
import {
   type QuicklySmsFormErrors,
   type QuicklySmsFormValues,
} from "@/utils/integrations/smsValidation";

interface QuicklySmsFieldsProps {
   values: QuicklySmsFormValues;
   errors: QuicklySmsFormErrors;
   /** True when editing the currently stored provider — blank secrets keep the stored ones. */
   secretOptional: boolean;
   onChange: (field: keyof QuicklySmsFormValues) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function QuicklySmsFields({values, errors, secretOptional, onChange}: QuicklySmsFieldsProps) {
   const {t} = useTranslation("partners");
   const secretHelper = secretOptional ? t("smsIntegration.form.secretKeepHelper") : undefined;

   return (
      <>
         <Input
            id="sms-quickly-url"
            type="text"
            name="url"
            label={t("smsIntegration.form.url")}
            placeholder={t("smsIntegration.form.urlPlaceholder")}
            value={values.url}
            onChange={onChange("url")}
            error={!!errors.url}
            helperText={errors.url}
            data-testid="sms-quickly-url"
         />
         <Input
            id="sms-quickly-api-key"
            type="passwordShow"
            name="apiKey"
            label={t("smsIntegration.form.apiKey")}
            value={values.apiKey}
            onChange={onChange("apiKey")}
            error={!!errors.apiKey}
            helperText={errors.apiKey ?? secretHelper}
            data-testid="sms-quickly-api-key"
         />
         <Input
            id="sms-quickly-api-secret"
            type="passwordShow"
            name="apiSecret"
            label={t("smsIntegration.form.apiSecret")}
            value={values.apiSecret}
            onChange={onChange("apiSecret")}
            error={!!errors.apiSecret}
            helperText={errors.apiSecret ?? secretHelper}
            data-testid="sms-quickly-api-secret"
         />
      </>
   );
}
